var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddLicencesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 16.3333H4.16667V4.66667H10V3H4.16667C3.24167 3 2.5 3.75 2.5 4.66667V16.3333C2.5 17.25 3.24167 18 4.16667 18H15.8333C16.75 18 17.5 17.25 17.5 16.3333V10.5H15.8333V16.3333ZM11.6667 3V4.66667H14.6583L6.46667 12.8583L7.64167 14.0333L15.8333 5.84167V8.83333H17.5V3H11.6667Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLicencesIcon);
export default __webpack_public_path__ + "static/media/addLicencesIcon.911c75c865bb270fc05daf4a72294756.svg";
export { ForwardRef as ReactComponent };